import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {NbButtonModule, NbFormFieldModule, NbIconModule, NbInputModule, NbPopoverModule} from '@nebular/theme';
import {TuiDayRange} from '@taiga-ui/cdk';
import {TuiCalendarRange, TuiInputDateRange} from "@taiga-ui/kit";
import {TuiTextfield, TuiTextfieldComponent, TuiTextfieldOptionsDirective} from '@taiga-ui/core'

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker-component.html',
  imports: [
    NbFormFieldModule,
    TuiCalendarRange,
    NbIconModule,
    NbInputModule,
    NbPopoverModule,
    NbButtonModule,
    ReactiveFormsModule,
    FormsModule, TuiInputDateRange, TuiTextfield,
    TuiTextfieldComponent,
    TuiTextfieldOptionsDirective
  ],
  styles: `:host {
    min-width: 190px
  }`
})
export class DatepickerComponent implements OnInit {
  control = new UntypedFormControl();

  @Input() value: TuiDayRange;
  @Output() rangeSelect: EventEmitter<TuiDayRange> = new EventEmitter<TuiDayRange>();

  ngOnInit() {
    if (this.value) {
      this.control.patchValue(this.value);
    }
  }

  dateFilter(dayRange: TuiDayRange) {
    this.control.patchValue(
      dayRange.from.getFormattedDay('YMD', '-') + ' ' + dayRange.to.getFormattedDay('YMD', '-')
    );

    this.rangeSelect.emit(dayRange);
  }

  clear(): void {
    this.control.patchValue(null);
  }
}
